import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { MatchMaker as MatchMakerFlow } from '@libs/creditkit';

import { scoreQueries } from '@common/queries/score';
import { useUserContext } from '@common/contexts/UserContext';
import { LoaderCircular } from '@common/components/LoaderCircular';
import { LoggedInHeader } from '@common/components/LoggedInHeader';
import { LoggedOutHeader } from '@common/components/LoggedOutHeader';

export function MatchMaker() {
  const { data: negativeDebts } = useQuery({
    ...scoreQueries.negative(),
  });
  const { user, getTokens } = useUserContext();

	const { accessToken } = getTokens();

  if (!accessToken || !user) return <LoaderCircular fullPage />;
  return (
    <MatchMakerFlow
      user={user}
      token={accessToken}
      negativeDebts={negativeDebts}
      headers={{
        loggedIn: <LoggedInHeader username={user?.full_name} />,
        loggedOut: <LoggedOutHeader />,
      }}
    />
  );
}
